import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step1 } from '../../../../shared/models/component-messages/simp_in/step1';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';
import { UrlSecurite } from '../models/UrlSecurite';
import { Oui } from '../models/Oui';
@Component({
	selector: 'app-url-securite',
	templateUrl: './url-securite.component.html'
})
export class UrlSecuriteComponent implements OnInit {
	@Input() uid = '';
	public current_uid = 'UrlSecurite';
	@Input() parentForm: FormGroup;

	@Input() disabled: boolean;
	@Input() urlSecurite: UrlSecurite;

	public step1 = new Step1();

	public radioButtonValue: string;

	constructor() {}

	public ngOnInit() {
		if ((this.urlSecurite.non === RadioCheckBoxEnum.emptyValue || this.urlSecurite.non === 'Non') && this.urlSecurite.oui == null) {
			this.urlSecurite.non = RadioCheckBoxEnum.nonValue;
		}
		else if (this.urlSecurite.oui) {
			this.urlSecurite.non = RadioCheckBoxEnum.ouiValue;
		}
		else {
			this.urlSecurite.non = RadioCheckBoxEnum.emptyValue;
		}
	}

	getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	}

	isUrlSecuriteOui() {
		if (this.parentForm.controls[this.getUid() + '_SepAtt_non'].value === 'Oui') {
			if (!this.urlSecurite.oui) {
				this.urlSecurite.oui = new Oui();
			}
      		return true;
    	}
    
    	this.urlSecurite.oui = null;
    	return false;
	}
}
